import {
  Component,
  OnInit,
  Input,
  forwardRef,
  OnChanges,
  SimpleChange,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, FormControl, FormArray } from "@angular/forms";
import { RadioComponent } from "../radio/radio.component";
import { FormBaseElement } from "../form-base-element";
import { Observable } from "rxjs";

@Component({
  selector: "app-checkbox",
  templateUrl: "./checkbox.component.html",
  styleUrls: ["./checkbox.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent extends FormBaseElement {
  @Input() checked: boolean = false;
  @Input() elementValue: any;
  @Input() control: FormArray;
  @Input("disableCheckbox") disableCheckbox: boolean = false;

  constructor() {
    super();
  }

  switch(elementValue) {
    if (!this.control.value.includes(elementValue)) {
      this.control.push(new FormControl(elementValue));
    } else {
      const index = this.control.value.indexOf(elementValue);
      this.control.removeAt(index);
    }
  }
}
